var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTimedOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.192,
    height: 54.282,
    viewBox: "0 0 53.192 54.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_TimedOut",
    transform: "translate(394.308 -59.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    "data-name": "Path 3589",
    d: "M-368.418,60.087A25.881,25.881,0,0,1-343.3,80.576a25.085,25.085,0,0,1-1.577,15.455.594.594,0,0,0,.187.82,9.322,9.322,0,0,1,2.937,9.778,9.208,9.208,0,0,1-7.476,7.012,9.355,9.355,0,0,1-9.576-3.542.541.541,0,0,0-.733-.205,24.185,24.185,0,0,1-10.631,1.532,25.235,25.235,0,0,1-18.323-9.675,24.424,24.424,0,0,1-5.271-12.069,24.977,24.977,0,0,1,4.635-18.9,25.029,25.029,0,0,1,16.2-10.163C-371.444,60.343-369.923,60.258-368.418,60.087Zm7.407,44.179a2.339,2.339,0,0,0-.236.069,19.6,19.6,0,0,1-9.863,1.151,19,19,0,0,1-10.275-4.655A19.56,19.56,0,0,1-388.131,83.7a1.07,1.07,0,0,1,1.119-1.065,1.067,1.067,0,0,1,.905,1.245c-.038,1.045-.1,2.095-.043,3.137a17,17,0,0,0,4.443,10.647A17.732,17.732,0,0,0-360.931,102a.776.776,0,0,0,.372-.427,9.761,9.761,0,0,1,7.423-7,.715.715,0,0,0,.416-.309,17.193,17.193,0,0,0,2.09-7.38,17.172,17.172,0,0,0-4.932-13.34c-4.636-4.755-10.3-6.359-16.793-5.068a16.949,16.949,0,0,0-5.214,2.087,1,1,0,0,1-1.449-.325,1.017,1.017,0,0,1,.442-1.427,19.408,19.408,0,0,1,13.638-2.494,19.089,19.089,0,0,1,11.9,7.021,19.27,19.27,0,0,1,4.021,16.548c-.305,1.522-.888,2.988-1.327,4.426l3.553.959A23.457,23.457,0,0,0-354.3,66.925a23.519,23.519,0,0,0-30.976,2.411,23.548,23.548,0,0,0-1.578,31.227,23.337,23.337,0,0,0,26.613,7.364Zm17.573-.159a7.739,7.739,0,0,0-7.733-7.714,7.773,7.773,0,0,0-7.7,7.71,7.775,7.775,0,0,0,7.724,7.741A7.738,7.738,0,0,0-343.438,104.106Z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    "data-name": "Path 3590",
    d: "M-304.123,132.039c0,2.015.031,4.031-.024,6.045a2.121,2.121,0,0,1-.521,1.317c-2.835,2.894-5.71,5.748-8.578,8.61-.629.628-1.27.691-1.815.2a1.2,1.2,0,0,1,.068-1.853c2.317-2.326,4.585-4.7,6.986-6.94a4.259,4.259,0,0,0,1.5-3.608c-.123-3.278-.04-6.564-.036-9.846,0-.884.356-1.4,1-1.493a1.209,1.209,0,0,1,1.413,1.332C-304.117,127.884-304.123,129.961-304.123,132.039Z",
    transform: "translate(-62.169 -51.941)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M-352.321,117.235c1.152,0,1.739,1.005,1.2,1.809-.793,1.189-1.637,2.344-2.493,3.49a1.118,1.118,0,0,1-1.558.252,1.121,1.121,0,0,1-.425-1.525c.835-1.259,1.733-2.478,2.645-3.683C-352.785,117.363-352.43,117.292-352.321,117.235Z",
    transform: "translate(-30.085 -44.92)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M-202,238.974c0-1.142-.005-2.284,0-3.426.005-.888.464-1.428,1.2-1.437s1.222.52,1.227,1.409q.019,3.426,0,6.851c-.007.9-.486,1.389-1.259,1.365-.726-.023-1.162-.533-1.169-1.4C-202.008,241.216-202,240.095-202,238.974Z",
    transform: "translate(-150.55 -136.474)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M-200.778,278.345a1.2,1.2,0,0,1-1.19-1.177,1.258,1.258,0,0,1,1.236-1.217,1.221,1.221,0,0,1,1.175,1.2A1.16,1.16,0,0,1-200.778,278.345Z",
    transform: "translate(-150.568 -168.062)",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimedOut);
export default __webpack_public_path__ + "static/media/icon_TimedOut.ddc28b56aafdcce8ab05165da09c8832.svg";
export { ForwardRef as ReactComponent };